import type {FormStatus} from 'nutshell-graphql-types';
import type {GetMcfxFormsVariables as GetMcfxFormsQueryVariables} from 'nutshell-graphql-types';

export const DEFAULT_FORM_LIST_LIMIT = 20;

export function getConnectedFormListQueryVariables(
    isFilteringOnIgnored: boolean,
    statuses?: FormStatus[] | null,
    limit?: number | null
): GetMcfxFormsQueryVariables {
    return {
        filters: {
            ignored: isFilteringOnIgnored,
            statuses,
        },
        limit: limit ? limit : DEFAULT_FORM_LIST_LIMIT,
    };
}
